<template>

    <div>
        <div class="modal fade" style="display: block; opacity: 1;" tabindex="-1" id="modalCreatePilot">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <button type="button" @click="closeModal" class="close" data-dismiss="modal" aria-label="Close">
                    <em class="icon ni ni-cross"></em>
                </button>
                <div class="modal-header">
                    <h5 class="modal-title">{{ translations.forms.competitor.title_create }}</h5>
                </div>
                <div class="modal-body">

                    <form>

                        <div class="form-group row">
                            <div class="col">
                                <label for="firstname">{{ translations.forms.competitor.firstname }}*</label>
                                <input id="firstname" v-model="firstname" type="text" required="required" class="form-control">
                            </div>
                            <div class="col">
                                <label for="lastname">{{ translations.forms.competitor.lastname }}*</label>
                                <input id="lastname" v-model="lastname" type="text" required="required" class="form-control">
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col">
                                <label for="email">{{ translations.forms.competitor.email }}*</label>
                                <input id="email" v-model="email" type="text" required="required" class="form-control">
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col">
                                <label for="street">{{ translations.forms.competitor.street }}*</label>
                                <input id="street" v-model="street" type="text" required="required" class="form-control">
                            </div>

                            <div class="col-3">
                                <label for="number">{{ translations.forms.competitor.number }}*</label>
                                <input id="number" v-model="number" type="text" required="required" class="form-control">
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col">
                                <label for="city">{{ translations.forms.competitor.city }}*</label>
                                <input id="city" v-model="city" type="text" required="required" class="form-control">
                            </div>

                            <div class="col-3">
                                <label for="zipcode">{{ translations.forms.competitor.zipcode }}*</label>
                                <input id="zipcode" v-model="zipcode" type="text" required="required" class="form-control">
                            </div>

                            <div class="col-3">
                                <label for="country">{{ translations.forms.competitor.country }}*</label>
                                <input id="country" v-model="country" type="text" required="required" class="form-control">
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-3">
                                <label for="nationality">{{ translations.forms.competitor.nationality }}*</label>
                                <input id="nationality" v-model="nationality" type="text" required="required" class="form-control">
                            </div>

                            <div class="col-3">
                                <label for="language">{{ translations.forms.competitor.language }}*</label>
                                <input id="language" v-model="language" type="text" required="required" class="form-control">
                            </div>

                            <div class="col">
                                <label for="mobile_number">{{ translations.forms.competitor.mobile_number }}*</label>
                                <input id="mobile_number" v-model="mobile_number" type="text" required="required" class="form-control">
                            </div>
                        </div>

                        <hr>

                        <div class="form-group row">
                            <div class="col-3">
                                <label for="day_license">{{ translations.forms.competitor.day_license }}</label>
                                <div class="g">
                                    <div class="custom-control custom-control-sm custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" id="day_license" v-model="day_license">
                                        <label class="custom-control-label" for="day_license"></label>
                                    </div>
                                </div>
                            </div>

                            <div class="col-3">
                                <label for="license_number">{{ translations.forms.competitor.license_number }}</label>
                                <input id="license_number" v-model="license_number" type="text" class="form-control" placeholder="WXXXXR">
                            </div>

                            <div class="col">
                                <label for="club">{{ translations.forms.competitor.club }}</label>
                                <input id="club" v-model="club" type="text" class="form-control">
                            </div>
                        </div>

                    </form>

                </div>
                <div class="modal-footer bg-light">
                    <button type="button" @click="saveCompetitor" class="btn btn-success">{{ translations.forms.competitor.save }}</button>
                </div>
            </div>
        </div>
    </div>
        <div class="modal-backdrop fade show"></div>
    </div>

</template>

<script>
    export default {
        name: 'addPilotModal',
        props: [
            'translations',
        ],

        data() {
            return {
                firstname: '',
                lastname: '',
                email: '',
                street: '',
                number: '',
                city: '',
                zipcode: '',
                country: '',
                nationality: '',
                language: '',
                mobile_number: '',
                day_license: false,
                license_number: '',
                club: '',
            }
        },

        methods: {
            saveCompetitor() {
                // do api call to the server so the competitor gets created
                axios.post('/api/internal/events/registration/create-pilot', {
                    user_id: parseInt(USER_ID),
                    type: 'pilot',
                    firstname: this.firstname,
                    lastname: this.lastname,
                    email: this.email,
                    street: this.street,
                    number: this.number,
                    city: this.city,
                    zipcode: this.zipcode,
                    country: this.country,
                    nationality: this.nationality,
                    language: this.language,
                    mobile_number: this.mobile_number,
                    day_license: this.day_license,
                    license_number: this.license_number,
                    club: this.club,
                }).then((response) => {

                    this.$emit('onSave', response.data.pilot);

                    NioApp.Toast(response.data.message, 'success', {position: 'top-right', timeOut: 5000});
                }).catch((errors) => {
                    console.log(errors);
                });
            },
            closeModal() {
                this.$emit('closeModal');
            }
        }
    }
</script>
